import PayoutsChartWidget from './PayoutsChartWidget';

export default PayoutsChartWidget;
